<template>
  <form class="flex w-full overflow-x-hidden" id="form-activity" autocomplete="off" >
    <div class="w-full p-2" >
      <div class="flex flex-col items-center mb-6">
        <div class="px-4 mb-6">
          <img
            alt="..."
            class="shadow rounded max-w-full h-auto align-middle border-none"
            :src="input.cover?input.cover:imgPlaceholder"
            style="width: 150px;"
          />
        </div>
        <div class="flex flex-col mb-2">
          <p class="text-xs text-gray-700">Input 596 x 304 px image in JPG or PNG. Max image size 1MB</p>
        </div>
        <div class="flex flex-col mb-2" v-if="isFileLarge || isFileWrongFormat || ($v.input.cover.$dirty && !$v.input.cover.required)">
          <text-error v-if="isFileLarge" text="Please select correct file" />
          <text-error v-if="isFileWrongFormat" text="Please use a valid image format" />
          <text-error v-if="$v.input.cover.$dirty && !$v.input.cover.required" text="Please select category image." />
        </div>
        <div class="flex">
          <Button label="Browse File" v-if="!input.cover">
            <template v-slot:any>
              <input style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;opacity: 0;cursor: pointer;z-index: 2;"
                     type="file"
                     name="profile_picture"
                     @change="onFileChange"
              />
            </template>
          </Button>
          <Button label="Cancel" variant="default" v-if="input.cover" @clicked="changeImage"></Button>
        </div>
      </div>
      <form-item label='Category Name'>
        <template v-slot>
          <Input
            v-model="input.name"
            placeholder="Category Name"
            :error="$v.input.name.$dirty && (!$v.input.name.required || !$v.input.name.maxLength)"
            maxlength="100"
          />
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.name.$dirty && !$v.input.name.required" text="Please fill Category Name." />
            <text-error v-if="$v.input.name.$dirty && !$v.input.name.maxLength" text="Max length Category name is 100 character." />
          </div>
        </template>
      </form-item>
    </div>
  </form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { maxLength, required } from 'vuelidate/lib/validators';
import helpersMixin from '@/mixins/helpers.mixins';
import { mapActions } from 'vuex';
import axios from 'axios';
import { FormItem, Input, Button, TextError } from '@/components/Layout/Form';
import imgPlaceholder from '@/assets/image-placeholder.jpeg';

const initialStateCategory = {
  id: null,
  name: '',
  cover: null,
};

export default {
  name: 'CategoriesForm',
  mixins: [validationMixin, helpersMixin],
  props: {
    toggleReset: {
      type: Boolean,
      default: () => false,
    },
    categories: {
      type: Object,
      default: rawProps => ({ ...rawProps }),
    },
    typeCategories: {
      type: String,
    },
  },
  data() {
    return {
      maxLengthDesc: 750,
      dragover: false,
      isFileLarge: false,
      isFileWrongFormat: false,
      isError: false,
      input: { ...initialStateCategory },
      imgPlaceholder
    };
  },
  validations() {
    return {
      input: {
        cover: {
          required,
        },
        name: {
          required,
          maxLength: maxLength(100),
        },
      },
    };
  },
  mounted() {},
  watch: {
    toggleReset: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetState();
        }
      },
    },
  },
  methods: {
    ...mapActions('CategoriesModule', [
      'requestAddCategories', 'requestEditCategories',
    ]),
    resetState() {
      this.$v.$reset();
      this.isError = false;
      this.isFileLarge = false;
      this.isFileWrongFormat = false;
      this.input = Object.assign({}, this.categories);
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.isFileLarge && !this.isFileWrongFormat) {
        const data = { ...this.input };
        if (this.categories.cover !== this.input.cover) {
          data.cover = await axios({
            method: 'get',
            url: this.input.cover,
            responseType: 'blob',
          })
            .then(this.processFileBlob);
        } else {
          delete data.cover;
        }
        if (this.categories.id) {
          await this.requestEditCategories({ data, type: this.typeCategories });
        } else {
          await this.requestAddCategories({ data, type: this.typeCategories });
        }
        this.$emit('on-submit-category', true);
      }
    },
    processFileBlob(response) {
      const file = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
      return file.then(data => data);
    },
    onFileChange(e) {
      this.isFileLarge = false;
      this.isFileWrongFormat = false;
      const file = e.target.files[0];
      const image = new Image();
      image.onload = (ev) => {
        if ((image.width !== 596 && image.height !== 304)) {
          this.$v.dirty = true;
          this.isFileWrongFormat = true;
        }
      };
      if (file.size > 1024 * 1024) {
        this.$v.dirty = true;
        this.isFileLarge = true;
      }
      this.input.cover = URL.createObjectURL(file);
      image.src = this.input.cover;
    },
    changeImage() {
      this.input.cover = null;
    },
  },
  components: { FormItem, Input, Button, TextError },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Categories/CategoriesForm.vue